<template>
<div v-html="component.html" class="component-html"></div>  
</template>

<script>
export default {
props: ['component']
}
</script>